/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { autoBeforeEachTest } from '@jira/platform__utils-auto-before-each-test/src/auto-before-each-test.tsx';
import { isPendoReady, logError } from './isPendoReady.tsx';

type Attributes = Record<string, string | number | boolean>;

type PendoEvent = {
	actionSubjectAndAction: `${string} ${string}`;
	actionSubjectId?: string;
	source?: string;
	attributes?: Attributes;
};

const QUEUE_LIMIT = 50;
let queue: Array<[string, Attributes | undefined]> = [];
autoBeforeEachTest(() => {
	queue.length = 0;
});

const waitForPendoReadiness = () => {
	// This code should not execute on the server.
	if (__SERVER__) {
		return;
	}
	const interval = setInterval(() => {
		if (isPendoReady()) {
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			queue.forEach(([event, attributes]) => window?.pendo?.track(event, attributes));
			queue = [];
			clearInterval(interval);
		}
	}, 1000);
};

/**
 * @deprecated passing event as string is deprecated, use `sendPendoTrackEvent(event: PendoEvent)` call instead
 */
export function sendPendoTrackEvent(event: string, properties?: Attributes): void;
export function sendPendoTrackEvent(event: PendoEvent): void;
export function sendPendoTrackEvent(event: string | PendoEvent, properties?: Attributes): void {
	let pendoEvent;
	let attributes;

	if (typeof event === 'string') {
		pendoEvent = event;
		attributes = properties;
	} else {
		const fullEvent = [event.source, event.actionSubjectAndAction, event.actionSubjectId]
			.filter((part) => part !== undefined)
			.join(' - ');

		pendoEvent = fullEvent;
		attributes = event.attributes;
	}

	try {
		if (isPendoReady()) {
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			window.pendo.track(pendoEvent, attributes);
		} else {
			queue.length < QUEUE_LIMIT && queue.push([pendoEvent, attributes]);
			waitForPendoReadiness();
		}
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (err: any) {
		logError('pendoTrackEvent', err);
	}
}

export const updatePendoVisitorOptions = (metadata: {}): void => {
	try {
		if (isPendoReady()) {
			// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
			window.pendo.updateOptions(metadata);
		}
		// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (err: any) {
		logError('pendoUpdateOptions', err);
	}
};
